




















































import { computed, defineComponent, watch } from '@vue/composition-api';

export default defineComponent({
	props: {
		value: {
			type: Boolean,
		},
		title: {
			type: String,
		},
		error: {
			type: String,
		},
		loading: {
			type: Boolean,
		},
		icon: {
			type: String,
			default: 'mdi-exclamation-thick',
		},
		iconColor: {
			type: String,
			default: 'warning',
		},
		hideIcon: {
			type: Boolean,
			default: false,
		},
		message: {
			type: [String, Array],
		},
		button: {
			type: String,
		},
		buttonColor: {
			type: String,
			default: 'green',
		},
		buttonDisabled: {
			type: Boolean,
			default: false,
		},
		cleanup: {
			type: String,
		},
		contentClass: {
			type: String,
		},
		showCancelButton: {
			type: Boolean,
			default: true,
		},
	},
	emits: ['confirm', 'cleanup'],
	setup(props, { root, emit }) {
		const open = computed<boolean>({
			get: () => props.value ?? false,
			set: (value: boolean) => emit('input', value),
		});

		const messages = computed(() => (Array.isArray(props.message) ? props.message : [props.message]));

		watch(
			() => [open.value, props.cleanup],
			([value]) => {
				if (!value) {
					if (props.cleanup) {
						root.$store.dispatch(props.cleanup);
					}
					emit('cleanup');
				}
			}
		);

		return {
			open,
			messages,
		};
	},
});
